import type { FaireProductEntity } from "../../entity_types/product";

export const p_23v64ddyn7: FaireProductEntity = {
  token: "p_23v64ddyn7",
  type: "product",
  name: "Big Heart Sticker",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/703cc996a6cec76ad6e8e46447382dc5c87805944821c8552396722a24bb88ae.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/df49b4be5f5253b6225840edf2b413bafc043163056f08b8347ab9f623008faa.jpeg",
    "https://cdn.faire.com/fastly/5ec0d5d1c2008c92a4cbf5c0b86d404b6ecd4a1a09078d4336fffae4aed8ca40.png",
  ],
  priceDollars: 2.5,
  description:
    "Water-resistant, Die-cut Stickers with crack and peel backing. Have fun decorating those laptops and water bottles!",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:24.067Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
